import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// ✅ request log
apiClient.interceptors.request.use((config) => {
  console.log("API:", config.method?.toUpperCase(), (config.baseURL || "") + (config.url || ""));
  return config;
});

// ✅ error log
apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    console.log("API ERROR STATUS:", err?.response?.status);
    console.log("API ERROR DATA:", err?.response?.data);
    return Promise.reject(err);
  }
);

export default apiClient;